import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import UsrControlModal from './modals/UserControlModal';
import { fetchUserControl, adminAction } from './Api';

const UsrControl = () => {
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('All');
  const [users, setUsers] = useState([]); // Dynamic data
  const [selectedUser, setSelectedUser] = useState(null);
  const [showModal, setShowModal] = useState(false);


  const loadUsers = async () => {
    try {
      const data = await fetchUserControl();
      setUsers(data);
    } catch (error) {
      console.error('Error fetching user control data:', error);
    }
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const handleUserClick = (user) => {
    setSelectedUser(user);
    setShowModal(true);
  };

  const filteredUsers = users.filter((user) => {
    const name = user.target_user_name ?? user.full_name ?? '';
    return name.toLowerCase().includes(search.toLowerCase());
  });

  const handleAdminAction = async ({ target_user_ids, action_type, reason, ban_expires_at }) => {
    try {
      if (!target_user_ids || target_user_ids.length === 0) {
        console.warn('No target users selected.');
        return;
      }

      // Call adminAction with the array of IDs
      await adminAction({
        target_user_ids,
        action_type,
        reason,
        ban_expires_at,
      });

      setShowModal(false);
      await loadUsers(); // Refresh user list
    } catch (error) {
      console.error('Failed to send admin action:', error);
      alert('Failed to perform action. Please try again.');
    }
  };



  return (
    <div
      className="p-4 w-100"
      style={{
        backgroundColor: '#ff9b45',
        color: '#FFECC8',
        minHeight: '100%',
        boxShadow: '0 0 10px rgba(0,0,0,0.05)',
      }}
    >
      <h5 className="mb-4 fw-bold">User Control</h5>

      <div className="d-flex mb-3 gap-2">
        <input
          type="text"
          className="form-control"
          placeholder="Search user..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

      </div>


      <div
        className="table-responsive"
        style={{
          maxHeight: 'calc(10 * 2.5rem + 1rem)', // ~10 rows
          overflowY: filteredUsers.length > 10 ? 'auto' : 'visible',
        }}
      >


        <table className="table table-bordered table-hover mb-0">
          <thead className="table-light">
            <tr>
              <th>Users</th>
              <th>Credit Score</th>
              <th>Account Type</th>
              <th>Deleted</th>

            </tr>
          </thead>

          <tbody>
            {filteredUsers.map((user) => {
              const initials = user.full_name
                ? user.full_name
                  .split(' ')
                  .map((n) => n[0])
                  .join('')
                  .toUpperCase()
                : '?';

              return (
                <tr
                  key={user.id}
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleUserClick(user)}
                >
                  <td style={{ paddingRight: '10px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      {user.profile_image ? (
                        <img
                          src={`${user.profile_image}?t=${Date.now()}`}
                          alt={user.full_name}
                          style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            objectFit: 'cover',
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: '#6c757d', // Bootstrap gray-600
                            color: '#ffffff',            // white text for contrast
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 'bold',
                            fontSize: '14px',
                            textTransform: 'uppercase',
                          }}
                        >
                          {initials}
                        </div>
                      )}
                      <span>{user.target_user_name || user.full_name}</span>
                    </div>
                  </td>
                  <td style={{ paddingLeft: '5px' }}>{user.credit_score}</td>
                  <td style={{ paddingLeft: '5px' }}>{user.account_type}</td>

                  <td style={{ paddingLeft: '5px' }}>
                    {user.deleted_at
                      ? new Date(user.deleted_at).toLocaleString('en-PH', {
                        timeZone: 'Asia/Manila',
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                      })
                      : '-'}
                  </td>


                </tr>
              );
            })}
          </tbody>


        </table>
      </div>



      {/* Modal */}
      {selectedUser && (
        <UsrControlModal
          show={showModal}
          onClose={() => setShowModal(false)}
          user={selectedUser}
          onAction={({ action_type, reason, ban_expires_at }) =>
            handleAdminAction({
              target_user_ids: [selectedUser.id], // always an array
              action_type,
              reason,
              ban_expires_at,
            })

          }

        />
      )}
    </div>
  );
};

export default UsrControl;